import axios from 'axios'
import { hostMetricas } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

// Types/Constants
const CREAR_METRICA = 'CREAR_METRICA'


export const crearMetricas = createAsyncThunk(
    CREAR_METRICA,
    async (data) => {
        try {
            const fullUrl = `${hostMetricas}Metricas/Solicitudes/metrica`
            const res = await axios.post(fullUrl, data)
            return res.data.data
        } catch (error) {
            console.error("Error al crear métrica:", error)
            throw error
        }
    }
)

// Initial State
const initialState = {
    metricas: [],
    usuariosOC: [],
    loading: false,
    error: null,
    ultimoRegistro: null
}

// Slice
export const metricasSlice = createSlice({
    name: 'metricas',
    initialState,
    reducers: {
        resetMetricasState: (state) => {
            state.metricas = []
            state.usuariosOC = []
            state.loading = false
            state.error = null
            state.ultimoRegistro = null
        }
    },
    extraReducers: (builder) => {
        builder
            // crearMetricas
            .addCase(crearMetricas.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(crearMetricas.fulfilled, (state, { payload }) => {
                state.loading = false
                state.ultimoRegistro = payload
                state.metricas.push(payload)
            })
            .addCase(crearMetricas.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message
            })
    }
})

export const { resetMetricasState } = metricasSlice.actions
export default metricasSlice.reducer
